import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	categories: [],
	categoriesMap: {},
};

export const categoriesSlice = createSlice({
	name: 'categories',
	initialState,
	reducers: {
		setCategories: (state, action) => {
			state.categories = action.payload;
			state.categoriesMap = action.payload.reduce((acc, category) => {
				acc[category.id] = category;
				return acc;
			}, {});
		},
	},
});

export const { setCategories } = categoriesSlice.actions;

export default categoriesSlice.reducer;
